module.exports = __webpack_public_path__ + "img/main.00f76c7.webp";